import React, { useState, useEffect,useRef } from 'react';
import './SubmissionReportPapers.css';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import Select, { components } from 'react-select';
import DatePicker from 'react-datepicker';
import { format, parseISO } from 'date-fns';
import 'react-datepicker/dist/react-datepicker.css';
import { showToast } from '../toastUtils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons';
//import React from 'react';
//import DatePicker from 'react-datepicker';
import html2pdf from 'html2pdf.js';
import FullscreenLoader from '../FullscreenLoader';
import { queuedApiFetch, apiFetch } from '../api';
import * as XLSX from 'xlsx';

function SubmissionReport() {

  const contentRef = useRef();
  // const columnOptions = [ //'Proj_Number',
  //   'Sno', 'Proj_Name', 'Proj_ShortName', 'Proj_Manager_Name', 'Proj_Director_Name',
  //   'Proj_Dept', 'Proj_Address', 'CPRS_Number', 'CPRS_Approval_Date', 'Proj_Approved_Budget',
  //   'Proj_Cost', 'Construction_Cost', 'GFA', 'Proj_StartDate', 'Proj_EndDate',
  //   'Exptd_Cons_StartDate', 'Exptd_Cons_EndDate', 'Exptd_Main_Contractor_Calling_Date',
  //   'Exptd_Main_Contract_Award_Date', 'Contractual_Cons_StartDate', 'Contractual_Cons_EndDate',
  //   'Actual_Cons_EndDate', 'Proj_Stage', 'Proj_Progress_Status', 'Potential_Extn_of_Time',
  //   'Granted_Extn_of_Time', 'CSC_Date', 'Handover_Date', 'TOP_Date', 'DLP_Expiry_Date',
  //   'Consultant_Names', 'Contractor_Names', 'Building_Code', 'Exptd_appnmt_of_Consultants',
  //   'Exptd_Handover_Date', 'Exptd_Authority_submissions', 'Actual_Authority_submissions','Contractor','Arch', 'CS', 'ME', 'QS'
  // ];

  //'sno',

  const columnOptions = [ //'Proj_Number',
    'sc_sn_number', 'tender_ref_no', 'contractor', 'arch', 'me',
    'cs', 'qs', 'procurment_type', 'epv', 'doc_submsn_date',
    'apv', 'status', 'submsn_remarks'
  ];

  const getUserDetails = localStorage.getItem('userDetails');
  const userDetails = getUserDetails ? JSON.parse(getUserDetails) : '';
  const userId = userDetails ? userDetails.id : '';
  const getUserAccess = userDetails ? userDetails.access_level : '';
  const [rows, setRows] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState(columnOptions);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);  
  const [sortDirection, setSortDirection] = useState('asc'); 
  const getUserEmail = localStorage.getItem('userEmail');

  // const fetchWBSData = () => {
  //   setIsLoading(true);
  //   const requestOptions = {
  //     method: 'GET',
  //     //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
  //   };

  //   queuedApiFetch('/project/getprojectmaster', requestOptions)
  //     .then((response) => response.json())
  //     .then((data) => {
  //       if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
  //         setRows(data.data);
  //         setIsLoading(false);
  //       }
  //     })
  //     .catch((error) => console.error('Error fetching data:', error))
  //     .finally(() => setIsLoading(false));
  // };


  

  const fetchSubmsn_proc_papersDetails = async () => {
    setIsLoading(true);
    const requestOptions = {
      method: 'GET',
      //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
    };

    try {
      const response = await queuedApiFetch(`/project/get_submsn_proc_papers?userid=${userId}&email_id=${getUserEmail}`,
        requestOptions
      );
      const data = await response;

      if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
        setRows(data.data);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setIsLoading(false);
    }
  };
  

  useEffect(() => {
    if (userId) {
      fetchSubmsn_proc_papersDetails();
    }
  }, [userId]);

  // const handleExport = async () => {
  //   const workbook = new ExcelJS.Workbook();
  //   const worksheet = workbook.addWorksheet('Export');    
  //   const orderedColumns = selectedColumns.includes('Sno')
  //     ? ['Sno', ...selectedColumns.filter(col => col !== 'Sno')]
  //     : selectedColumns;

  //   worksheet.columns = orderedColumns.map(column => {
  //     const header = labelMapping[column] || column.replace(/_/g, ' ').toUpperCase();
  //     return { header, key: column };
  //   });

  //   rows.forEach(row => {
  //     const rowData = {};

  //     orderedColumns.forEach(column => {
  //       let value = row[column] || '';
  //       const dateValue = new Date(value);

  //       if (
  //         value && !isNaN(dateValue.getTime()) &&
  //         typeof value === 'string' && value.trim() !== '' &&
  //         /\d{4}-\d{2}-\d{2}/.test(value)
  //       ) {
  //         // Format dates
  //         //rowData[column] = dateValue.toLocaleDateString('en-US');
  //         const day = String(dateValue.getDate()).padStart(2, '0');
  //         const month = String(dateValue.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  //         const year = dateValue.getFullYear();
  //         rowData[column] = `${day}-${month}-${year}`;
  //       } else if (
  //         ['Proj_Approved_Budget', 'Proj_Cost', 'Construction_Cost'].includes(column) &&
  //         typeof value === 'number'
  //       ) {
  //         // Format currency columns as $XXX,XXX.00
  //         rowData[column] = new Intl.NumberFormat('en-US', {
  //           style: 'currency',
  //           currency: 'USD',
  //           minimumFractionDigits: 0,
  //           maximumFractionDigits: 0
  //         }).format(value);
  //       } else {
  //         // Other columns
  //         rowData[column] = value;
  //       }
  //     });

  //     worksheet.addRow(rowData);
  //   });

  //   // Export to Excel file
  //   workbook.xlsx.writeBuffer().then(buffer => {
  //     saveAs(new Blob([buffer]), 'ProjectMasterList.xlsx');
  //   });
  // };  

  const handleExport = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Export');

    const orderedColumns = selectedColumns.includes('sno')
      ? ['sno', ...selectedColumns.filter(col => col !== 'sno')]
      : selectedColumns;

    worksheet.columns = orderedColumns.map(column => {
      const header = labelMapping[column] || column.replace(/_/g, ' ').toUpperCase();
      return { header, key: column };
    });

    // Initialize auto-increment counter for "sno"
    let snoCounter = 1;

    rows.forEach(row => {
      const rowData = {};

      orderedColumns.forEach(column => {
        if (column === 'sno') {
          // Set auto-incremented value for "sno"
          rowData[column] = snoCounter++;
        } else {
          let value = row[column] || '';
          const dateValue = new Date(value);

          if (
            value && !isNaN(dateValue.getTime()) &&
            typeof value === 'string' && value.trim() !== '' &&
            /\d{4}-\d{2}-\d{2}/.test(value)
          ) {
            // Format dates to dd-mm-yyyy
            const day = String(dateValue.getDate()).padStart(2, '0');
            const month = String(dateValue.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
            const year = dateValue.getFullYear();
            rowData[column] = `${day}-${month}-${year}`;
          } else if (
            ['epv', 'apv'].includes(column) &&
            typeof value === 'number'
          ) {
            // Format currency columns as $XXX,XXX.00
            rowData[column] = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD',
              minimumFractionDigits: 0,
              maximumFractionDigits: 0
            }).format(value);
          } else {
            // Other columns
            rowData[column] = value;
          }
        }
      });

      worksheet.addRow(rowData);
    });

    // Export to Excel file
    workbook.xlsx.writeBuffer().then(buffer => {
      saveAs(new Blob([buffer]), 'SubmissionOfProcurementPapersList.xlsx');
    });
  };


  const labelMapping = {
    // sno: 'SC Number',
    sc_sn_number: 'SC Number',
    tender_ref_no: 'Tender_Ref_No',
    contractor: 'Contractor',
    // Proj_Number: 'Project Number',
    arch: 'Arch',
    me: 'M&E',
    cs: 'CS',
    qs: 'QS',
    procurment_type: 'Procurement Type',
    epv: 'EPV',
    doc_submsn_date: 'Document Submission Date',
    apv: 'APV',
    status: 'Status',
    submsn_remarks: 'Submission Remarks',    
  };

  const options = [
    { value: 'selectAll', label: 'Select All' },
    ...columnOptions.map(column => ({
      value: column,
      label: labelMapping[column] || column.replace(/_/g, ' ').toUpperCase()
    }))
  ];

  const handleColumnChange = (selectedOptions) => {
    if (selectedOptions.some(option => option.value === 'selectAll')) {
      if (selectedColumns.length < columnOptions.length) {
        setSelectedColumns(columnOptions); // Select all columns
      } else {
        setSelectedColumns([]); // Deselect all columns
      }
    } else {
      setSelectedColumns(selectedOptions.map(option => option.value));
    }
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      width: '100%',  // Adjust width as needed
      borderColor: state.isFocused ? '#B0B0B0' : '#E0E0E0',  // Light gray border color on focus
      borderRadius: '8px',
      padding: '5px',
      boxShadow: state.isFocused ? '0 0 5px rgba(176, 176, 176, 0.5)' : 'none', // Light gray focus box-shadow
    }),
    menu: (provided) => ({
      ...provided,
      marginTop: '5px',
      borderRadius: '8px',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.05)', // Lighter shadow
    }),
    option: (provided, state) => ({
      ...provided,
      padding: '10px',
      backgroundColor: state.isSelected ? '#B0B0B0' : state.isFocused ? '#F8F8F8' : '#fff', // Lighter gray background when selected
      color: state.isSelected ? '#fff' : '#333', // White text on selected
      borderRadius: '4px',
      cursor: 'pointer',
      ':active': {
        backgroundColor: '#B0B0B0', // Active state lighter gray background
        color: '#fff',
      },
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: '#B0B0B0',  // Lighter gray background for multi-value
      borderRadius: '4px',
      color: '#fff',
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: '#fff',
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: '#fff',
      ':hover': {
        backgroundColor: '#D3D3D3',  // Lighter gray color for remove icon hover
      },
    }),
  };


  const handleEditField = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);
  };

  // const updateProjectMasterList = () => {
  //   setSubmitLoading(true);
  //   if (!submitLoading) {
  //     const sendData = rows;
  //     const requestOptions = {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'ngrok-skip-browser-warning': '69420'
  //       },
  //       body: JSON.stringify(sendData),
  //     };
  //     queuedApiFetch('/project/updateprojectmaster', requestOptions)
  //       .then((response) => response.json())
  //       .then((result) => {
  //         // alert(result.message || 'Data saved successfully');
  //         showToast.success('Data saved successfully');
  //         setSubmitLoading(false);          
  //       })
  //       .catch((error) => console.error('Error saving data:', error));
  //   }
  // };   

  const updateSubmissionReportList = async () => {
    // Avoid submitting if already in progress
    if (submitLoading) return;

    setSubmitLoading(true);

    const sendData = rows;
    const requestOptions = {
      method: 'POST',
      // headers: {
      //   'Content-Type': 'application/json',
      //   'ngrok-skip-browser-warning': '69420',
      // },
      body: JSON.stringify(sendData),
    };

    try {
      const response = await queuedApiFetch(`/project/upsert_submsn_proc_papers`,
        requestOptions
      );
      const result = await response;

      // Check if the response status is successful
      if (result.apistatus.Status_Code === 200 && result.apistatus.Status_Description.toLowerCase() === 'success') {
        showToast.success('Data saved successfully');
      } else {
        showToast.error(result.apistatus.Status_Description || 'Error occurred. Please try again.');
      }
    } catch (error) {
      console.error('Error saving data:', error);
      showToast.error('Something went wrong. Please try again.');
    } finally {
      setSubmitLoading(false); // Ensure loading state is reset after completion
    }
  };

  const CustomValueContainer = ({ children, ...props }) => {
    const selectedOptions = props.getValue();

    let displayValue;
    if (selectedOptions.length <= 2) {
      displayValue = selectedOptions.map(opt => opt.label).join(', ');
    } else {
      const displayedLabels = selectedOptions.slice(0, 2).map(opt => opt.label);
      const moreCount = selectedOptions.length - 2;
      displayValue = `${displayedLabels.join(', ')} + ${moreCount} more`;
    }

    return (
      <components.ValueContainer {...props}>
        <span>{displayValue}</span>
        {children[1]}
      </components.ValueContainer>
    );
  };

  const CustomOption = (props) => {
    return (
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
          style={{ marginRight: 8 }}
        />
        <label>{props.label}</label>
      </components.Option>
    );
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date)) return '';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);
  };


      // for sorting icon implementation 
  
      const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });

      const sortRows = (rows, config) => {
        const sortedRows = [...rows];
        if (config.key) {
          sortedRows.sort((a, b) => {
            let aValue = a[config.key];
            let bValue = b[config.key];
    
            // Handle sorting for tender_ref_no field by extracting numbers after '_'
            if (config.key === 'tender_ref_no') {
              const extractNumber = (value) => {
                const match = value.match(/_(\d+)$/); // Match numbers after the last '_'
                return match ? parseInt(match[1], 10) : 0; // Return the number after '_' or 0 if not found
              };
    
              aValue = extractNumber(aValue);
              bValue = extractNumber(bValue);
            } else {
              // For other fields (e.g., Proj_Name), perform normal string comparison
              if (typeof aValue === 'string') {
                aValue = aValue.toLowerCase();
              }
              if (typeof bValue === 'string') {
                bValue = bValue.toLowerCase();
              }
            }
    
            // Compare the values and sort in the specified direction
            if (aValue < bValue) return config.direction === 'asc' ? -1 : 1;
            if (aValue > bValue) return config.direction === 'asc' ? 1 : -1;
            return 0;
          });
        }
        return sortedRows;
      };

      const handleSort = () => {
        const newSortDirection = sortDirection === 'asc' ? 'desc' : 'asc';
        setSortDirection(newSortDirection);
    
        const sortedRows = [...rows].sort((a, b) => {
          const projNameA = a.Proj_Name.toLowerCase();
          const projNameB = b.Proj_Name.toLowerCase();
    
          if (newSortDirection === 'asc') {
            return projNameA.localeCompare(projNameB); // Ascending order
          } else {
            return projNameB.localeCompare(projNameA); // Descending order
          }
        });
    
        setRows(sortedRows);
      };
    

      const handleDownloadPDF = () => {
          const element = contentRef.current;
      
          // Clone element and set wider width for full scroll capture
          const cloned = element.cloneNode(true);
          cloned.style.width = element.scrollWidth + "px";
            cloned.style.height = element.scrollHeight + "px";
      
            // Invisible container to render content without affecting layout
        const container = document.createElement("div");
        container.style.position = "absolute";
        container.style.left = "-9999px";
        container.style.top = "0";
        container.appendChild(cloned);
        document.body.appendChild(container);
      
          const opt = {
            margin: 0,
            filename: "SubmissionOfProcurementPapersList.pdf",
            image: { type: "jpeg", quality: 0.98 },
            html2canvas: {
              scale: 1,
              scrollX: 0,
              scrollY: 0,
              width: element.scrollWidth, // capture full scroll width
              windowWidth: element.scrollWidth,
              height: element.scrollHeight, // capture full scroll height
              windowHeight: element.scrollHeight,
            },
            jsPDF: {
              unit: "px",
              format: [element.scrollWidth, element.scrollHeight, element.offsetHeight],
              orientation: element.scrollWidth > element.scrollHeight ? "landscape" : "portrait",
              //orientation: "landscape",
            },
          };
      
          html2pdf().set(opt).from(cloned).save()
          .then(() => {
            // Clean up
            document.body.removeChild(container);
          });
        };

  const handleDownloadCSV = () => {

    const keys = Object.keys(labelMapping);
    // const csvRows = [
    //   keys.map(key => labelMapping[key]), // header row
    //   ...rows.map(row => keys.map(key => row[key] ?? '')) // data rows
    // ];

    const csvRows = [
      keys.map(key => `"${labelMapping[key]}"`), // Header row with labels
      ...rows.map(row => keys.map(key => escapeCSVValue(row[key]))) // Data rows with sanitization
    ];

    const csvContent = csvRows.map(e => e.join(',')).join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = 'SubmissionOfProcurementPapersList.csv';
    link.click();

    URL.revokeObjectURL(url); // clean up
  };

  const escapeCSVValue = (value) => {
    if (value == null) return '';

    let str = String(value).trim();

    // Normalize all unicode to block obfuscation (e.g., curly quotes → straight quotes)
    str = str.normalize('NFKC');

    // Escape double quotes (RFC-compliant)
    str = str.replace(/"/g, '""');

    // Protect against formula injection
    if (/^[=+\-@]/.test(str)) {
      // Completely neutralize potential formula, don’t just prefix with `'`
      // Option 1: prefix space (safe and minimal disruption)
      str = ` ${str}`;
    }

    // Extra protection: remove known dangerous formula fragments (if any remain)
    const lowerStr = str.toLowerCase();
    const dangerousKeywords = ['cmd|', '/c', 'powershell', 'shell', 'cmd.exe', 'notepad', 'calc'];
    for (const keyword of dangerousKeywords) {
      if (lowerStr.includes(keyword)) {
        // Completely strip the content or replace it
        //str = '[removed for safety]';
        str = '';
        break;
      }
    }

    return `"${str}"`;
  };

  const handleDownloadXLSX = () => {
      // const keys = Object.keys(labelMapping);
      const keys = selectedColumns;
      // Build worksheet data
      const worksheetData = [
        keys.map(key => labelMapping[key]), // Header row with mapped labels
        ...rows.map(row => keys.map(key => sanitizeXLSXValue(row[key]))) // Data rows with sanitization
      ];
  
      // Create worksheet & workbook
      const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "SubmissionOfProcurementPapers");
  
      // Export to file
      XLSX.writeFile(workbook, "SubmissionOfProcurementPapersList.xlsx");
    };
  
  
    // Sanitize cell values for safety & consistency
    const sanitizeXLSXValue = (value) => {
      if (value == null) return '';
  
      let str = String(value).trim();
      str = str.normalize('NFKC'); // normalize unicode
  
      // Neutralize potential formula injection
      if (/^[=+\-@]/.test(str)) {
        str = ` ${str}`; // prefix with safe space
      }
  
      // Extra protection against dangerous keywords
      const lowerStr = str.toLowerCase();
      const dangerousKeywords = ['cmd|', '/c', 'powershell', 'shell', 'cmd.exe', 'notepad', 'calc'];
      for (const keyword of dangerousKeywords) {
        if (lowerStr.includes(keyword)) {
          str = '';
          break;
        }
      }
  
      return str;
    };

  return (
    <div className="bodywrapp" style={{ width: '100%' }}>
      {isLoading && <FullscreenLoader />} 
      <div className="header" style={{ width: '95%' }}>
        <div className="projectwrap">
          <div className="addwbswrap" style={{background: '#e7e6e6'}} >
            <button disabled={rows && rows.length == 0 ? true : false} onClick={handleDownloadXLSX}>Export Excel</button>
            <button style={{marginLeft: '30px'}} disabled={rows && rows.length == 0 ? true : false} onClick={handleDownloadPDF}>Export PDF</button>
          </div>
          <button id="submit" disabled={submitLoading || rows.length == 0 ? true : false} onClick={updateSubmissionReportList}>Submit</button>
        </div>
      </div>

      <div id="sub_paper_list" >

        <div className="filter-wrap" style={{ width: '95%' }}>
          <Select
            isMulti
            name="columns"
            options={options}
            value={options.filter(option => selectedColumns.includes(option.value))}
            onChange={handleColumnChange}
            closeMenuOnSelect={false}
            placeholder="Select Columns"
            hideSelectedOptions={false}
            styles={customStyles}
            components={{
              ValueContainer: CustomValueContainer,
              Option: CustomOption,
            }}
          />
        </div>

        <div ref={contentRef} className="tablewrap" style={{ width: '90%', overflowX: 'auto', overflowY: 'auto', height: 'calc(100vh - 276px)' }}>
          <table id="wbsTable">
            <thead>
              <tr>
                {/* {selectedColumns.includes('sno') && <th className="description-column">SC Number</th>} */}
                {selectedColumns.includes('sc_sn_number') && <th className="description-column">SC Number</th>}
                {selectedColumns.includes('tender_ref_no') && <th className="description-column">Tender_Ref_No</th>}
                           {/* {selectedColumns.includes('tender_ref_no') && (
                               <th onClick={handleSort}>
                                 Tender_Ref_No
                                 {sortDirection === 'asc' ? (
                                   <FontAwesomeIcon icon={faSortUp} />
                                 ) : (
                                   <FontAwesomeIcon icon={faSortDown} />
                                 )}
                               </th>
                             )} */}
                {/* {selectedColumns.includes('tender_ref_no') && <th className="description-column">Tender_Ref_No</th>}   */}
                {selectedColumns.includes('contractor') && <th className="description-column">Contractor</th>}
                {selectedColumns.includes('arch') && <th className="description-column">Arch</th>}
                {selectedColumns.includes('me') && <th className="description-column">M&E</th>}
                {selectedColumns.includes('cs') && <th className="description-column">CS</th>}
                {selectedColumns.includes('qs') && <th className="description-column">QS</th>}
                {selectedColumns.includes('procurment_type') && <th className="description-column">Procurement Type</th>}
                {selectedColumns.includes('epv') && <th className="description-column">EPV</th>}
                {selectedColumns.includes('doc_submsn_date') && <th style={{ minWidth: '100px' }} className="description-column">Document Submission Date</th>}
                {selectedColumns.includes('apv') && <th className="description-column">APV</th>}
                {selectedColumns.includes('status') && <th className="description-column">Status</th>}     
                {selectedColumns.includes('submsn_remarks') && <th className="description-column">Submission Remarks</th>}        

                
              </tr>
            </thead>
            <tbody>
              {selectedColumns.length === 0 ? (
                <tr>
                  <td colSpan='13' style={{ height: '100px', padding: '20px' }}>Please Select any one column</td>
                </tr>
              )
                :
                rows.length === 0 ? (
                  <tr>
                    <td colSpan='13' style={{ height: '100px', padding: '20px',textAlign:'center' }}>{isLoading ? 'Loading...' : 'No records found'}</td>
                  </tr>
                )
                  :
                  (
                    rows.map((row, index) => (
                      <tr key={index}>                        
                        {/* {selectedColumns.includes('sno') && <td>{index + 1}</td>} */}
                        {selectedColumns.includes('sc_sn_number') && <td>{row.sc_sn_number}</td>}
                        {selectedColumns.includes('tender_ref_no') && <td>{row.tender_ref_no}</td>}
                        {selectedColumns.includes('contractor') && <td>{row.contractor}</td>}
                        {selectedColumns.includes('arch') && <td>{row.arch}</td>}
                        {selectedColumns.includes('me') && <td>{row.me}</td>}
                        {selectedColumns.includes('cs') && <td>{row.cs}</td>}
                        {selectedColumns.includes('qs') && <td>{row.qs}</td>}
                        {selectedColumns.includes('procurment_type') && <td>{row.procurment_type}</td>}
                        {selectedColumns.includes('epv') && <td> 
                          <input
                            // disabled={getUserAccess == 'project_admin' ? false : true}
                            type="number"
                            value={row.epv}
                            onChange={(e) =>
                              handleEditField(index, 'epv', e.target.value)
                            }
                          />
                        </td>}
                        {selectedColumns.includes('doc_submsn_date') && <td>
                          <DatePicker
                            // disabled={getUserAccess == 'project_admin' ? false : true}
                            selected={row.doc_submsn_date ? parseISO(row.doc_submsn_date, 'yyyy-MM-dd', new Date()) : null}
                            onChange={(date) => {
                              const formattedDate = (date==null)?date:format(date, 'yyyy-MM-dd');
                              handleEditField(index, 'doc_submsn_date', formattedDate);
                            }}
                            dateFormat="dd-MM-yyyy"
                            placeholderText="DD-MM-YYYY"
                          />
                        </td>}
                        {selectedColumns.includes('apv') && <td>
                          <input
                            // disabled={getUserAccess == 'project_admin' ? false : true}
                            type="text"
                            value={row.apv}
                            onChange={(e) =>
                              handleEditField(index, 'apv', e.target.value)
                            }
                          />
                        </td>}
                        {selectedColumns.includes('status') && <td> 
                          <input
                            // disabled={getUserAccess == 'project_admin' ? false : true}
                            type="text"
                            value={row.status}
                            onChange={(e) =>
                              handleEditField(index, 'status', e.target.value)
                            }
                          />
                        </td>}
                        {selectedColumns.includes('submsn_remarks') && <td> 
                          <textarea
                            // disabled={getUserAccess == 'project_admin' ? false : true}
                            type="text"
                            value={row.submsn_remarks}
                            onChange={(e) =>
                              handleEditField(index, 'submsn_remarks', e.target.value)
                            }
                          />
                        </td>}
                      </tr>
                    ))
                  )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default SubmissionReport;
